import { render, staticRenderFns } from "./LendingPage_StartNow.vue?vue&type=template&id=0ba701ce&scoped=true&"
import script from "./LendingPage_StartNow.vue?vue&type=script&lang=js&"
export * from "./LendingPage_StartNow.vue?vue&type=script&lang=js&"
import style0 from "./LendingPage_StartNow.vue?vue&type=style&index=0&id=0ba701ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba701ce",
  null
  
)

export default component.exports